export default __webpack_public_path__ + "static/media/aylaLogoLight.76cbe4b6.svg";